import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { PrivacyPolicyService } from '../../services/privacy-policy.service';

export const privacyPolicyGuard: CanActivateFn = (_route, state: RouterStateSnapshot) => {
  const privacyPolicyService = inject(PrivacyPolicyService);
  const router = inject(Router);

  if (state.url.startsWith('/privacy-policy')) {
    return of(true);
  }

  return privacyPolicyService.getMyStatus().pipe(
    map(status => {
      if (status.hasAcceptedLatest || !status.currentPolicy) {
        return true;
      }

      return router.createUrlTree(['/privacy-policy'], {
        queryParams: { returnUrl: state.url }
      });
    }),
    catchError(() => of(router.createUrlTree(['/privacy-policy'], {
      queryParams: { returnUrl: state.url }
    }))),
    take(1)
  );
};
